import React from 'react';
const DGColumn = ({}) => React.createElement("div", null);
export default DGColumn;
